export default __webpack_public_path__ + "static/media/post11.1a61922c.jpg";